import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../context/AuthContext";
import Logo from "./Logo";
import LanguageSwitcher from "./LanguageSwitcher";
import "./Navigation.css";

const Navigation = () => {
    const { t } = useTranslation();
    const { user, logout } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const closeMenu = () => setIsMenuOpen(false);
    const isActive = (path) =>
        location.pathname === path || location.pathname.startsWith(path + "/");

    const handleLogout = async () => {
        await logout();
        navigate("/client-portal");
        closeMenu();
    };

    return (
        <nav className="navigation">
            <div className="navigation__container">
                <Link to="/" className="navigation__logo" onClick={closeMenu}>
                    <Logo />
                </Link>

                <span className="navigation__spacer" />

                <ul
                    className={`navigation__menu ${isMenuOpen ? "navigation__menu--open" : ""}`}
                >
                    <li className="navigation__item">
                        <Link
                            to="/"
                            className={`navigation__link ${isActive("/") && location.pathname === "/" ? "navigation__link--active" : ""}`}
                            onClick={closeMenu}
                        >
                            {t("nav.home")}
                        </Link>
                    </li>

                    {!user && (
                        <li className="navigation__item">
                            <Link
                                to="/client-portal"
                                className={`navigation__link ${isActive("/client-portal") ? "navigation__link--active" : ""}`}
                                onClick={closeMenu}
                            >
                                {t("nav.portal")}
                            </Link>
                        </li>
                    )}

                    {user &&
                        user.role === "client" &&
                        user.account_status === "active" && (
                            <li className="navigation__item">
                                <Link
                                    to="/dashboard"
                                    className={`navigation__link ${isActive("/dashboard") ? "navigation__link--active" : ""}`}
                                    onClick={closeMenu}
                                >
                                    {t("nav.dashboard")}
                                </Link>
                            </li>
                        )}

                    {user && user.role === "admin" && (
                        <li className="navigation__item">
                            <Link
                                to="/admin"
                                className={`navigation__link ${isActive("/admin") ? "navigation__link--active" : ""}`}
                                onClick={closeMenu}
                            >
                                {t("nav.admin")}
                            </Link>
                        </li>
                    )}
                </ul>

                <div className="navigation__actions">
                    <LanguageSwitcher />
                    {user && (
                        <button
                            className="navigation__logout-btn"
                            onClick={handleLogout}
                        >
                            {t("nav.logout")}
                        </button>
                    )}
                </div>

                <button
                    className="navigation__menu-toggle"
                    onClick={() => setIsMenuOpen((o) => !o)}
                    aria-label="Toggle menu"
                >
                    <FontAwesomeIcon icon={isMenuOpen ? faTimes : faBars} />
                </button>
            </div>
        </nav>
    );
};

export default Navigation;
